import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ContactOptions, FooterConfig, InfoOptions, SocialMediaOptions } from '../../../models/footer-model';


@Component({
  selector: 'ubs-footer',
  templateUrl: './ubs-footer.component.html',
  styleUrls: ['./ubs-footer.component.scss']
})
export class UbsFooterComponent implements OnInit,AfterViewInit,OnChanges {
  @Input()footerConfig:FooterConfig;
  now = new Date();
  datetimeString = this.now.toLocaleString();

  contactInfo:boolean = false;
  infoLinks:boolean = false;
  socialMediaLinks:boolean = false;
  contactOptions:ContactOptions;
  infoOptions:InfoOptions;
  socialMediaOptions:SocialMediaOptions

  @ViewChild('datetime') datetime:ElementRef<HTMLElement>;
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.datetime.nativeElement.innerHTML = this.datetimeString
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["footerConfig"]){
      if(this.footerConfig != undefined){
        console.log(this.footerConfig);
        this.contactInfo = this.footerConfig.contactInfo;
        this.contactOptions = this.footerConfig.contactOptions;
        this.infoLinks = this.footerConfig.infoLinks;
        this.infoOptions = this.footerConfig.infoOptions;
        this.socialMediaLinks = this.footerConfig.socialMediaLinks;
        this.socialMediaOptions = this.footerConfig.socialMediaOptions;
        //this.cdr.detectChanges();
      }
    }
  }

  infoKeys():Array<string>{
    if(this.infoOptions != undefined){
      return Object.keys(this.infoOptions); 
    }
  }

  socialMediaKeys():Array<string>{
    if(this.socialMediaOptions != undefined){
      return Object.keys(this.socialMediaOptions); 
    }
  }

  contactKeys():Array<string>{
    if(this.contactOptions != undefined){
      return Object.keys(this.contactOptions);
    }
  }
}
